/**
 * @typedef {{
 *     currentTab: number;
 *     furthestTab: number;
 * }} ContractFormState
 */


const AVAILABLE_FORM_STATES = {
	INACTIVE: 'inactive',
	CURRENT: 'current',
	COMPLETED: 'completed',
}

class handleTabSwitch {
	/**
	 * @param {HTMLFormElement} form
	 */
	constructor(form) {
		this.form = form;
		this.formId = this.form.id;
		const handler = {
			get: (target, property) => {
				return target[property];
			},
			set: (target, property, newValue) => {
				const previousValue = target[property];
				let shouldSwitchTab = previousValue !== newValue;

				if (property === 'currentTab') {
					// If currentTab changes, validate form if going forward
					const goingForward = newValue > previousValue;
					if (shouldSwitchTab && goingForward) {
						shouldSwitchTab = validateForm(form, this);
					}

					if (shouldSwitchTab) {
						// Get all tabs between (when switching) and set their correct state
						const [startValue, endValue] = [previousValue, newValue].sort();
						for (let i = startValue; i <= endValue; i += 1) {
							const previousTabElement = this.getTab(i).element;
							previousTabElement.dataset.tabState = goingForward ? AVAILABLE_FORM_STATES.COMPLETED : AVAILABLE_FORM_STATES.INACTIVE;
						}

						// Set current tab "current" state
						const tab = this.getTab(newValue)
						const tabElement = tab.element;
						tabElement.dataset.tabState = AVAILABLE_FORM_STATES.CURRENT;

						// Set furthest tab
						if (goingForward) {
							target['furthestTab'] = newValue;
							persistForm(this.formId, newValue, getFormData(form))
						}

						this.updateNavigationButtons(tab);

						$(tabElement).tab('show');
						target[property] = newValue;
					}

				}

				if (property === 'furthestTab') {
					target[property] = newValue;
				}


				return true;
			}
		};

		/**
		 * @type {ContractFormState}
		 */
		this.state = new Proxy({ currentTab: 0, furthestTab: 0 }, handler)
	}

	/**
	 * Get tabs amount
	 * @returns {number}
	 */
	getTabsLength = () => {
		return [...this.form.querySelectorAll('.primary-nav-tabs button[role="tab"].nav-link')].length;
	}

	/**
	 * @typedef {{isFirst: boolean, contentElement: HTMLElement, isLast: boolean, index: string, state: string, element: HTMLButtonElement}} TabData
	 */
	/**
	 *
	 * @param {number} tabIndex
	 * @returns {TabData}
	 */
	getTab = (tabIndex) => {
		/**
		 * @type {HTMLButtonElement}
		 */
		const tab = this.form.querySelector(`.primary-nav-tabs button[role="tab"].nav-link:nth-child(${tabIndex + 1})`);
		/**
		 * @type {HTMLElement}
		 */
		const contentElement = document.getElementById(tab.getAttribute('aria-controls'));
		/**
		 * @type {TabData}
		 */
		return {
			element: tab,
			contentElement,
			index: tab.dataset.index,
			state: tab.dataset.tabState,
			isFirst: tabIndex === 0,
			isLast: tabIndex === this.getTabsLength() - 1,
		};
	}
	/**
	 * Return current tab data
	 * @returns {TabData}
	 */
	getCurrentTab = () => {
		return this.getTab(this.state.currentTab);
	}
	/**
	 * @param {number} tabIndex
	 */
	goToTab = (tabIndex) => {
		const lastIndex = this.getTabsLength() - 1;
		let targetTab = tabIndex;
		if (tabIndex < 0) targetTab = 0;
		else if (tabIndex > lastIndex) targetTab = lastIndex;
		this.state.currentTab = targetTab;
	}
	/**
	 * Go to previous tab
	 */
	previousTab = () => {
		this.goToTab(this.state.currentTab - 1)
	}
	/**
	 * Go to next tab
	 */
	nextTab = () => {
		this.goToTab(this.state.currentTab + 1)
	}
	/**
	 * Show/hide navigation buttons based on current tab
	 * @param {TabData} tab
	 */
	updateNavigationButtons = (tab) => {
		$(this.form.querySelector('button.form-navigation-button[data-action="previous-tab"]')).toggle(!tab.isFirst);
		$(this.form.querySelector('button.form-navigation-button[data-action="next-tab"]')).toggle(!tab.isLast);
		$(this.form.querySelector('fieldset.submit-wrapper')).toggle(tab.isLast);
	}
}
